import React from 'react';
import Link, { Props as LinkProps } from '@ff/ui/Link';
import { getHandlerByKey } from 'shared/lib/appHandlers';
import { IS_APP } from 'shared/lib/pathUtils';
import { styled } from '@ff/ui';

export interface Props extends LinkProps {
  appHandlerKey?: string;
  disabled?: boolean;
}

export default function ButtonLink(props: Props) {
  const { href, appHandlerKey, disabled, ...rest } = props;

  // If app page and handler is provided, use the handler, else use the href
  return (
    <StyledLink
      padding={{ _: '4px 18.5px', md: '8px 24px' }}
      textAlign='center'
      borderRadius='4px'
      fontSize='14px'
      lineHeight={{ _: '26px', md: '22px' }}
      letterSpacing={{ _: '0', md: '0.8px' }}
      {...rest}
      disabled={disabled}
      href={!IS_APP || !getHandlerByKey(appHandlerKey) ? href : undefined}
      onClick={IS_APP ? getHandlerByKey(appHandlerKey) : undefined}
      variant='outlineClearButton'
    />
  );
}

const StyledLink = styled(Link)({
  ":disabled": {
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
    borderColor: 'rgba(255, 255, 255, 0.2)',
    color: 'rgba(255, 255, 255, 0.5)',

    ':hover': {
      backgroundColor: 'transparent',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      color: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'initial',
    },
  },
});
